<template>
  <div class="d-flex full">
    <div class="d-flex center">
      <img src="../../assets/logo.png" />
      <div class="mt-5">
        <div class="desc  text-center">{{ des }}</div>
        <div class="text-danger text-center message">{{ message }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ShiyunPagesAuthJump",
  data() {
    return {
      sn: "",
      ticket: "",
      des: "正在登陆...",
      message: "",
    };
  },
  mounted() {
    this.sn = this.$route.query.sn;
    this.ticket = this.$route.query.ticket;
    this.eLogin();
  },
  methods: {
    eLogin() {
      this.$$.api
        .post("/kernel/authentication/apis/open/authorization/ticket", {
          sn: this.sn,
          ticket: this.ticket,
        })
        .then((result) => {
          this.$store.commit(
            "runtime/setAuthorizationToken",
            result.data.token
          );
          this.des = "登陆成功，正在获取用户数据...";
          this.oGetUser()
            .then(() => {
              return this.oGetCurrency();
            })
            .then(() => {
              this.des = "跳转至首页...";
              this.$$.navigate.to({ path: "/overview" });
            });
        })
        .catch((error) => {
          this.des = "登陆失败";
          this.message = "" + error.message;

          this.$$.toastr.error(error.message);
        });
    },
    oGetUser() {
      return new Promise((resolve) => {
        this.$$.api
          .post("/kernel/authentication/apis/biz/user/current")
          .then((res) => {
            this.$store.commit("runtime/setUserInfo", res.data.user);
            this.$store.commit("runtime/setAccountInfo", res.data.account);

            resolve(true);
          })
          .catch((e) => {
            this.message = "" + e.message;
            this.$$.toastr.error(`错误信息：${e.message}`);
          });
      });
    },
    oGetCurrency() {
      return new Promise((resolve) => {
        this.$$.api
          .post("kernel/transaction/apis/biz/currency/default")
          .then((res) => {
            localStorage.setItem("currency", JSON.stringify(res.data.currency));
            resolve(true);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.full {
  background: #fff;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
.center {
  flex-direction: column;
  align-items: center;
}
.desc {
  font-size: 1.85rem;
  font-weight: 500;
}
.message {
  padding-top: 5px;
  font-size: 1.25rem;
}
</style>
